import { DocumentMetadataPropertyReferenceEnum, DocumentMetadataPropertyTypeEnum, } from 'shared/domains/apollo/generated/types';
import { BooleanFilter } from './BooleanFilter';
import { CustomMetadataAllowedValuesFilter } from './CustomMetadataAllowedValuesFilter';
import { DateRangeFilter } from './DateFilter';
import { DistinctPropertyValueFilter } from './DistinctPropertyValueFilter';
import { FileSystemEntryFilter } from './FileSystemEntryFilter/FileSystemEntryFilter';
import { NumberRangeFilter } from './NumberRangeFilter';
import { UsersFilter } from './UsersFilter';
export function getMetadataPropertyFilter(props) {
    const { type, label, searchName, name, reference, allowedValues } = props;
    switch (type) {
        case DocumentMetadataPropertyTypeEnum.Boolean:
            return <BooleanFilter label={label} name={searchName}/>;
        case DocumentMetadataPropertyTypeEnum.Date:
        case DocumentMetadataPropertyTypeEnum.Datetime:
            return <DateRangeFilter label={label} name={searchName}/>;
        case DocumentMetadataPropertyTypeEnum.Number:
            return <NumberRangeFilter label={label} name={searchName}/>;
        case DocumentMetadataPropertyTypeEnum.List:
            if (allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.length) {
                return <CustomMetadataAllowedValuesFilter allowedValues={allowedValues} field={searchName} label={label}/>;
            }
            return <DistinctPropertyValueFilter filterKey={searchName} label={label} propertyName={name}/>;
        case DocumentMetadataPropertyTypeEnum.Reference: {
            if (reference === DocumentMetadataPropertyReferenceEnum.User) {
                return <UsersFilter label={label} name={searchName}/>;
            }
            return <FileSystemEntryFilter label={label} name={searchName}/>;
        }
        // The string types are not treated as filters, they are added as search modifiers
        case DocumentMetadataPropertyTypeEnum.SimpleText:
        case DocumentMetadataPropertyTypeEnum.MultiLineText:
        default:
            return null;
    }
}
